// Form validation, mirroring the API contract; the API remains the source of
// truth. The notification email is now a per-tenant profile (see validateEmail),
// so creating an alert only needs exactly one of targetPrice / pct.

export interface CreateFormInput {
  /** raw form value; empty string = not provided */
  targetPrice: string;
  /** raw form value; empty string = not provided */
  pct: string;
}

export type CreateBody = { targetPrice: number } | { pct: number };

export type ValidationResult =
  | { ok: true; body: CreateBody }
  | { ok: false; error: string };

export type EmailResult =
  | { ok: true; email: string }
  | { ok: false; error: string };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Validate the per-tenant notification email (used for setup and editing). */
export function validateEmail(raw: string): EmailResult {
  const email = raw.trim();
  if (!email) return { ok: false, error: "Email is required." };
  if (!EMAIL_RE.test(email)) return { ok: false, error: "Enter a valid email address." };
  return { ok: true, email };
}

export function validateCreate(input: CreateFormInput): ValidationResult {
  const hasTarget = input.targetPrice.trim() !== "";
  const hasPct = input.pct.trim() !== "";

  if (hasTarget === hasPct) {
    return { ok: false, error: "Provide exactly one of target price or percent." };
  }

  if (hasTarget) {
    const targetPrice = Number(input.targetPrice);
    if (!Number.isFinite(targetPrice) || targetPrice <= 0) {
      return { ok: false, error: "Target price must be a positive number." };
    }
    return { ok: true, body: { targetPrice } };
  }

  const pct = Number(input.pct);
  if (!Number.isFinite(pct) || pct === 0) {
    return { ok: false, error: "Percent must be a non-zero number." };
  }
  return { ok: true, body: { pct } };
}
